const hemData = [
  {
    dependant: 0,
    single: 0,
    joint: 0,
  },
  {
    dependant: 1,
    single: 457,
    joint: 403,
  },
  {
    dependant: 2,
    single: 457,
    joint: 283,
  },
  {
    dependant: 3,
    single: 457,
    joint: 268,
  },
  {
    dependant: 4,
    single: 457,
    joint: 257,
  },
  {
    dependant: 5,
    single: 457,
    joint: 257,
  },
  {
    dependant: 6,
    single: 457,
    joint: 257,
  },
  {
    dependant: 7,
    single: 457,
    joint: 257,
  },
  {
    dependant: 8,
    single: 457,
    joint: 257,
  },
  {
    dependant: 9,
    single: 457,
    joint: 257,
  },
  {
    dependant: 10,
    single: 457,
    joint: 257,
  },
];

const HemDependant = (numberOfApplicants, numberOfDependant) => {
  const dataIndex = hemData.findIndex(
    (p) => p.dependant === Number(numberOfDependant)
  );

  switch (Number(numberOfApplicants)) {
    case 1:
      return hemData[dataIndex].single;
    case 2:
      return hemData[dataIndex].joint;
    default:
      return hemData[dataIndex].single;
  }
};

export default HemDependant;
